import ProtectedAPIRepository from './ProtectedAPIRepository'
import DelayPercentageRM from '../responsemodel/DelayPercentageRM'
import Result from './Result'
import DelayPercentageDataMapper from '../datamapper/DelayPercentageDataMapper'
import APIResponseModel from './APIResponseModel'
import DelayPercentage from '../../models/DelayPercentage'

class DelayPercentageRepository extends ProtectedAPIRepository {
  private dataMapper = new DelayPercentageDataMapper()

  getDelayPercentage = async () => {
    const response = await this.post<APIResponseModel<DelayPercentageRM>>('/delayPercentage')
    if (response instanceof Result.Success) {
      const data: APIResponseModel<DelayPercentageRM> = response.data
      if (data.data !== null && data.data.items.length > 0 && data.data.items[0] !== null) {
        const delayPercentage = this.dataMapper.map(data.data.items[0])
        return new Result.Success(delayPercentage)
      } else {
        return new Result.Error(0, 'No delay percentage configuration found')
      }
    } else {
      return response
    }
  }

  addDelayPercentage = async (ro: AddDelayPercentageRequestObject) => {
    const response = await this.put<APIResponseModel<DelayPercentageRM>>('/delayPercentage', ro)
    if (response instanceof Result.Success) {
      const data: APIResponseModel<DelayPercentageRM> = response.data
      if (data.data !== null && data.data.items.length > 0 && data.data.items[0] !== null) {
        const delayPercentage = this.dataMapper.map(data.data.items[0])
        return new Result.Success(delayPercentage)
      } else {
        return new Result.Error(0, 'Data is null')
      }
    } else {
      return response
    }
  }

  updateDelayPercentage = async (ro: UpdateDelayPercentageRequestObject) => {
    const response = await this.patch<APIResponseModel<DelayPercentageRM>>('/delayPercentage', ro)
    if (response instanceof Result.Success) {
      const data: APIResponseModel<DelayPercentageRM> = response.data
      if (data.data !== null && data.data.items.length > 0 && data.data.items[0] !== null) {
        const delayPercentage = this.dataMapper.map(data.data.items[0])
        return new Result.Success(delayPercentage)
      } else {
        return new Result.Error(0, 'Data is null')
      }
    } else {
      return response
    }
  }
}

export default DelayPercentageRepository

export interface AddDelayPercentageRequestObject {
  initial_delay_percentage: number
  generation_delay_percentage: number
  allocation_delay_percentage: number
  finish_investigation_delay_percentage: number
  initial_closure_delay_percentage: number
  final_closure_delay_percentage: number
  qc_delay_percentage: number
  missed_initiation_delay_percentage?: number
}

export interface UpdateDelayPercentageRequestObject {
  id?: string
  initial_delay_percentage?: number
  generation_delay_percentage?: number
  allocation_delay_percentage?: number
  finish_investigation_delay_percentage?: number
  initial_closure_delay_percentage?: number
  final_closure_delay_percentage?: number
  qc_delay_percentage?: number
  missed_initiation_delay_percentage?: number
}
